import { useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import Button from "ui/base/Button";
import Modal from "ui/Modal";
import useToggle from "core/hooks/useToggle";
import Tile from "areas/account/ui/Tile";


Reload.Menu = ({ select, text, loading, ...props }) => {
	const [option, setOption] = useState(null);
	const [open, setOpen] = useState(false);
	const isMobile = useMediaQuery(t => t.breakpoints.down("sm"));

	const style = {
		button: {
			maxWidth: "fit-content",
			justifyContent: "flex-end",
			".MuiButton-loadingIndicator": { left: "initial" }
		}
	};

	const handleOpen = (value) => {
		setOption(value);
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
		setTimeout(() => setOption(null), 500);
	};
	const handleSelect = async () => {
		await select(option);
		handleClose();
	};

	const actions = [
		{ label: "Cancel", color: "error", onClick: handleClose },
		{ label: "Save", color: "success", onClick: handleSelect, loading }
	];

	return (
		<>
			<Button.Menu select={handleOpen} fullWidth={isMobile} sx={style.button} loading={loading} {...props} />
			<Modal.Confirmation open={open} onClose={handleClose} title="Save your settings" text={text(option)} actions={actions} />
		</>
	);
};

Reload.Tile = ({ value, text, reload, loading, children }) => {
	const [open, toggle] = useToggle();

	const click = async () => {
		await reload();
		toggle();
	};

	const actions = [
		{ label: "No", color: "error", onClick: toggle },
		{ label: "Yes", color: "success", onClick: click, loading }
	];

	return (
		<>
			<Tile.Checkbox
				value={value}
				click={toggle}
				title="Reload"
				description="Auto reload when my balance drops below:"
				action={children}
			/>
			<Modal.Confirmation open={open} title="Save settings" text={text} actions={actions} onClose={toggle} />
		</>
	);
};

export default function Reload({ checked, data, menu, confirmation, mutateReload, mutateThreshold, loading, pending }) {
	return (
		<>
			<Reload.Tile value={checked} text={confirmation.reload(checked)} reload={mutateReload} loading={loading}>
				<Reload.Menu
					display={menu.selected.threshold?.label}
					selected={data?.threshold}
					options={menu.options.threshold}
					select={mutateThreshold}
					text={confirmation.threshold}
					disabled={!checked}
					loading={pending}
				/>
			</Reload.Tile>
			<Tile.Icon
				icon="coin"
				title="Amount"
				description="Auto reload my account with:"
				action={
					<Reload.Menu
						display={menu.selected.amount?.label}
						selected={data?.amount}
						options={menu.options.amount}
						select={mutateReload}
						text={confirmation.amount}
						disabled={!checked}
						loading={pending}
					/>
				}
			/>
		</>
	);
};